/*
 * @Author: 吴文洁
 * @Date: 2019-06-10 13:50:07
 * @LastEditors: 吴文洁
 * @LastEditTime: 2020-12-31 11:25:44
 * @Description: 
 */
import { Gender, Grade } from '@/common/interface';

export const GRADE: Grade[] = [
  { label: "学前", value: 1004 },
  { label: "小班", value: 1001 },
  { label: "中班", value: 1002 },
  { label: "大班", value: 1003 },
  { label: "小学", value: 7 },
  { label: "一年级", value: 1 },
  { label: "二年级", value: 2 },
  { label: "三年级", value: 3 },
  { label: "四年级", value: 4 },
  { label: "五年级", value: 5 },
  { label: "六年级", value: 6 },
  { label: "初中", value: 14 },
  { label: "初中一年级", value: 11 },
  { label: "初中二年级", value: 12 },
  { label: "初中三年级", value: 13 },
  { label: "高中", value: 104 },
  { label: "高中一年级", value: 101 },
  { label: "高中二年级", value: 102 },
  { label: "高中三年级", value: 103 }
];

export const GENDER: Gender[] = [
  { label: "男", value: 1 },
  { label: "女", value: 2 }
];

export const ACTIVITY_TYPE: {
  [index: string]: string
}  = {
  'groupType': '团购',
  'bargainType': '砍价',
  'lessonType': '微传单',
  'tyType': '集赞',
  'solitaireType': '群接龙',
}

export enum ResponseText {
  ERROR = '服务器出错了',
  NOT_FOUND = '找不到页面',
  ERROR_DOWN = '服务器宕机啦',
  PARAM_ERROR = '参数错误'
}


export const majorNoticeText = `
      <p>非“小麦助教”SaaS用户不可使用</p>
      <p>详情请咨询<span style="color: #FF6152">400-6677-456</span></p>
      <p>小麦助教用户请在电脑/手机端使用</p>`;

export const MAX_NUM = 99999;
export const MIN_NUM = 1;

export const DECIMAL_MAX_NUM = 99999.99;
export const DECIMAL_MIN_NUM = 0.10;

export const SIZE_UNIT = 1024 * 1024;